import React from 'react';
import { Link } from 'react-router-dom';

import '../style/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h4>O nas</h4>
          <p>Kompland s.c. Krzysztof Czernek , Łukasz Sporek</p>
          <p>34-300 Żywiec ul.Wypoczynkowa 5</p>
          <p>NIP: 553-21-96-532</p>
          <p>REGON: 072382008</p>
        </div>

        <div className="footer-column">
          <h4>Kontakt</h4>
          <p><a href="tel:+48607109070">📞 +48 607 109 070</a></p>
          <p>📧 <a href="mailto:k.czernek@kompland.com.pl">k.czernek@kompland.com.pl</a></p>
          <p><a href="tel:+48601448554">📞+48 601 448 554</a></p>
          <p>📧 <a href="mailto:l.sporek@kompland.com.pl">l.sporek@kompland.com.pl</a></p>
        </div>

        <div className="footer-column">
          <h4>Linki</h4>
          <p><Link to="/oferta">Oferta</Link></p>
          <p><Link to="/helpdesk">Zgłoś problem</Link></p>
          <p><Link to="/remote">Pomoc zdalna</Link></p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 KompLand – Wszelkie prawa zastrzeżone.</p>
        <p><a href="/polityka-prywatnosci">Polityka prywatności</a></p>
      </div>
    </footer>
  );
};

export default Footer;
